import { Link, useLocation, useNavigate } from "react-router-dom";
import { Logo } from "./Logo";
import { scrollToId } from "./SmoothScroll";
import { CABINET, NAV, PHOTOS } from "@/lib/content";

const Credit = ({ p }) => (
  <li>
    « {p.title} », {p.author} —{" "}
    <a href={p.source} target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 hover:text-white">Wikimedia Commons</a>,{" "}
    <a href={p.licenseUrl} target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 hover:text-white">{p.license}</a>
  </li>
);

export const Footer = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const go = (id) => (pathname === "/" ? scrollToId(id) : navigate(`/#${id}`));

  return (
    <footer data-testid="site-footer" className="relative overflow-hidden bg-[#1C2826] text-[#FAF8F5]">
      <div className="mx-auto max-w-[1400px] px-5 pb-10 pt-24 sm:px-8 lg:px-12">
        <a href={CABINET.rdvUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-rdv-cta" className="group block w-fit text-left">
          <span className="eyebrow text-[#D9C193]">Premier échange</span>
          <span className="font-serif-d mt-4 block text-5xl font-light leading-none sm:text-7xl lg:text-8xl">
            Prendre <em className="italic text-[#D9C193] transition-colors group-hover:text-[#E5DEC9]">rendez-vous</em>
            <span className="ml-4 inline-block transition-transform duration-500 group-hover:translate-x-3">→</span>
          </span>
        </a>

        <div className="mt-20 grid gap-12 border-t border-[#E5DEC9]/15 pt-12 md:grid-cols-12">
          <div className="md:col-span-4">
            <Logo light />
            <p className="mt-6 text-sm leading-relaxed text-[#C9D2CD]">
              {CABINET.firm} — {CABINET.name}, avocate au barreau d'Aix-en-Provence.<br />{CABINET.address.join(", ")}
            </p>
            <p className="mt-3 text-sm text-[#C9D2CD]">
              <a href={CABINET.phoneHref} className="hover:text-white" data-testid="footer-phone-link">{CABINET.phone}</a> ·{" "}
              <a href={CABINET.mobileHref} className="hover:text-white" data-testid="footer-mobile-link">{CABINET.mobile}</a> ·{" "}
              <a href={`mailto:${CABINET.email}`} className="hover:text-white" data-testid="footer-email-link">{CABINET.email}</a>
            </p>
          </div>
          <nav className="md:col-span-3 md:col-start-6">
            <p className="eyebrow text-[#D9C193]">Navigation</p>
            <ul className="mt-5 space-y-2.5 text-sm">
              {NAV.map((n) => (
                <li key={n.id}><button data-testid={`footer-nav-${n.id}`} onClick={() => go(n.id)} className="link-underline text-[#E5E9E7]">{n.label}</button></li>
              ))}
            </ul>
          </nav>
          <div className="md:col-span-4">
            <p className="eyebrow text-[#D9C193]">Informations</p>
            <ul className="mt-5 space-y-2.5 text-sm">
              <li><Link to="/mentions-legales" data-testid="footer-mentions-link" className="link-underline text-[#E5E9E7]">Mentions légales</Link></li>
              <li><Link to="/confidentialite" data-testid="footer-privacy-link" className="link-underline text-[#E5E9E7]">Politique de confidentialité</Link></li>
            </ul>
            <p className="eyebrow mt-8 text-[#D9C193]">Crédits photographiques</p>
            <ul data-testid="footer-photo-credits" className="mt-4 space-y-2 text-xs leading-relaxed text-[#C9D2CD]">
              <Credit p={PHOTOS.hero} />
              <li>Portrait : droits réservés</li>
            </ul>
          </div>
        </div>
        <div className="mt-16 flex flex-col justify-between gap-3 border-t border-[#E5DEC9]/15 pt-6 text-xs text-[#AEB8B3] sm:flex-row">
          <p>© {new Date().getFullYear()} {CABINET.firm} — Pauline Rège Chanal, Avocate</p>
          <p>Les informations de ce site sont générales et ne constituent pas une consultation juridique.</p>
        </div>
      </div>
    </footer>
  );
};
